import { defineMessages } from 'react-intl';

export default defineMessages({
  reviewsName: {
    id: 'reviews.input.name',
    defaultMessage: 'Jméno',
  },
  reviewsEmail: {
    id: 'reviews.input.email',
    defaultMessage: 'E-mail',
  },
  reviewsEmailErrorRequired: {
    id: 'reviews.input.email.error.required',
    defaultMessage: 'Prosím zadejte e-mail',
  },
  reviewsEmailErrorInvalid: {
    id: 'reviews.input.email.error.invalid',
    defaultMessage: 'Prosím zadejte platný e-mail',
  },
  reviewsEmailErrorTaken: {
    id: 'reviews.input.email.error.taken',
    defaultMessage: 'Tento e-mail už byl použit',
  },
  reviewsEmailErrorFailed: {
    id: 'reviews.input.email.error.failed',
    defaultMessage: 'Chyba při kontrole e-mailu',
  },
  reviewsText: {
    id: 'reviews.input.text',
    defaultMessage: 'Vaše recenze',
  },
  reviewsTextErrorRequired: {
    id: 'reviews.input.text.error.required',
    defaultMessage: 'Prosím zadejte vaši recenzi',
  },
  reviewsTextErrorForbiddenWords: {
    id: 'reviews.input.text.error.forbiddenWords',
    defaultMessage: 'Vaše recenze obsahuje nevhodná slova: {forbiddenWords}',
  },
  reviewsTextErrorMaxLength: {
    id: 'reviews.input.text.error.maxLength',
    defaultMessage: 'Prosím zadejte kratší text recenze',
  },
  watchdogEmail: {
    id: 'watchdog.input.email',
    defaultMessage: 'Vepište svůj e-mail',
  },
  watchdogEmailErrorRequired: {
    id: 'watchdog.input.email.error.required',
    defaultMessage: 'Prosím zadejte e-mail',
  },
  watchdogEmailErrorInvalid: {
    id: 'watchdog.input.email.error.invalid',
    defaultMessage: 'Prosím zadejte platný e-mail',
  },
  watchdogEmailErrorTaken: {
    id: 'watchdog.input.email.error.taken',
    defaultMessage: 'Tento e-mail už byl použit',
  },
  watchdogEmailErrorFailed: {
    id: 'watchdog.input.email.error.failed',
    defaultMessage: 'Chyba při kontrole e-mailu',
  },
  emailErrorInvalid: {
    id: 'tnb.input.email.error.invalid',
    defaultMessage: 'Prosím zadejte platný e-mail',
  },
});
